define([],
    () => {

        return ['$filter',
            function () {
                return {
                    restrict: 'A',
                    scope: {
                        isOpen: '=isOpen',
                    },
                    link: function (scope, element) {
                        scope.$watch('isOpen', () => {
                            element.stop().slideToggle(500);
                        });

                    },
                };
            }];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerAnimatedCollapse.js